export type { AuthProvider, AuthState, AuthStatus, AuthUser } from "@token/shared";
export { authKey, useAuth } from "./provider";
export { installAuthGuard } from "./guard";
export { Auth0Provider, DemoAuthProvider, GoogleGisProvider, MockAuthProvider } from "@token/shared";

import type { AuthConfig } from "../config";
import { createAuthProvider as createSharedAuthProvider, type AuthProvider } from "@token/shared";

export function createAuthProvider(config: AuthConfig, apiUrl?: string): AuthProvider {
  return createSharedAuthProvider({
    appName: "portal",
    config,
    apiUrl,
    mockUser: {
      id: "portal-user-1",
      email: "investor@example.com",
      name: "Portal User",
    },
  });
}
